import { commandCenterLoansApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

const MONTHLY_VOLUME_MONTHS = 6;

export const COMMAND_CENTER_MONTHLY_VOLUME_ACTION_TYPE = createNamedActions(
  'commandCenterMonthlyVolume',
  {
    SET_MONTHLY_VOLUME: 'SET_MONTHLY_VOLUME',
  },
);

export const getCommandCenterMonthlyVolumeAction = catchAsyncActionError(() => async dispatch => {
  const fetchSafe = async () => {
    try {
      const { data } = await commandCenterLoansApi.getMonthlyVolume({
        months: MONTHLY_VOLUME_MONTHS,
        config: SKIP_FORBIDDEN_CONFIG,
      });

      return data ?? null;
    } catch {
      return null;
    }
  };

  try {
    const data = await fetchSafe();

    dispatch({
      type: COMMAND_CENTER_MONTHLY_VOLUME_ACTION_TYPE.SET_MONTHLY_VOLUME,
      payload: data,
    });
  } finally {
    // In a `finally` so the slice is marked loaded even when a swallowed 403
    // degrades to null — otherwise the zone skeleton never clears.
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.MONTHLY_VOLUME));
  }
});
